import { Action } from 'redux';

import { OpenGeocodingConfigDialog } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { GeocodingTaskInfo } from '../models/GeocodingTaskInfo';

export interface OpenGeocodingConfigDialogAction extends Action {
    geocodingTaskInfo: GeocodingTaskInfo;
}

export function getOpenGeocodingConfigDialogAction(geocodingTaskInfo: GeocodingTaskInfo): OpenGeocodingConfigDialogAction {
    return {
        type: OpenGeocodingConfigDialog,
        geocodingTaskInfo,
    };
}

export const isOpenGeocodingConfigDialog = isActionFactory<OpenGeocodingConfigDialogAction>(OpenGeocodingConfigDialog);
